import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Cookies from 'js-cookie';
import { Select, Label } from '../styling/StyledComponents';

const DataFilter = ({
  selectedProjectId,
  setSelectedProjectId,
  selectedQuestionId,
  setSelectedQuestionId
}) => {
  const [projects, setProjects] = useState([]);
  const [questions, setQuestions] = useState([]);
  const [filteredQuestions, setFilteredQuestions] = useState([]);

  // Fetch all projects
  const fetchProjects = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/projects`, {
        headers: {
          Authorization: `Bearer ${Cookies.get('token')}`
        },
        withCredentials: true
      });
      if (response.data.success) {
        setProjects(response.data.result);
      }
    } catch (error) {
      console.error("Error fetching projects:", error);
    }
  };

  // Fetch all questions
  const fetchQuestions = async () => {
    try {
      const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/questions`);
      if (response.data.success) {
        setQuestions(response.data.result);
        setFilteredQuestions(response.data.result);
      }
    } catch (error) {
      console.error("Error fetching questions:", error);
    }
  };

  useEffect(() => {
    fetchProjects();
    fetchQuestions();
  }, []);

  // Filter questions based on selected project
  useEffect(() => {
    if (selectedProjectId) {
      const filtered = questions.filter(
        question => question.project_id == selectedProjectId
      );
      setFilteredQuestions(filtered);
      setSelectedQuestionId(''); // Reset question selection when project changes
    } else {
      setFilteredQuestions(questions);
    }
  }, [selectedProjectId, questions]);

  const handleProjectChange = (e) => {
    setSelectedProjectId(e.target.value);
  };

  const handleQuestionChange = (e) => {
    setSelectedQuestionId(e.target.value);
  };

  return (
    <div className="flex-row center padding-m">
      <div className="flex-column m-margin">
        <Select
          value={selectedProjectId}
          onChange={handleProjectChange}
        >
          <option value="">Select a Projects</option>
          {projects.map(project => (
            <option key={project.id} value={project.id}>
              {project.name}
            </option>
          ))}
        </Select>
      </div>

      <div className="flex-column m-margin">
        <Select
          value={selectedQuestionId}
          onChange={handleQuestionChange}
          disabled={!selectedProjectId && filteredQuestions.length > 0}
        >
          <option value="">All Questions</option>
          {filteredQuestions.map(question => (
            <option key={question.id} value={question.id}>
              {question.question}
            </option>
          ))}
        </Select>
      </div>
    </div>
  );
};

export default DataFilter;